import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const REL_COURIERS_ORDERS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            orderCreatedAt: 'orderCreatedAt',
            storeId: 'storeId'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'c',
            orderCreatedAt: 'o',
            storeId: 's'
        })
    })
})()

export const REL_COURIERS_ORDERS_BY_ACTION = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            orderCreatedAt: 'orderCreatedAt',
            storeId: 'storeId',
            routeId: 'routeId'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'c',
            orderCreatedAt: 'o',
            storeId: 's',
            routeId: 'r'
        })
    })
})()

export const REL_USERS_ORDERS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'c'
        })
    })
})()

export const REL_GLOBAL_ORDERS_BY_PAYMENT_STATUS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            orderCreatedAt: 'orderCreatedAt'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'c',
            orderCreatedAt: 'o'
        })
    })
})()

export const REL_STORES_ORDERS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'c'
        })
    })
})()

export const REL_STORES_ORDERS_BY_ACTION = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'c'
        })
    })
})()

export const REL_STORES_ORDERS_BY_EOD = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'c'
        })
    })
})()

export const REL_STORES_PRODUCTS_BY_CATEGORY = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            visibility: 'visibility',
            display: 'display'
        }),
        [MODE_PROD]: Object.freeze({
            visibility: 'v',
            display: 'd'
        })
    })
})()

export const REL_STORES_PRODUCT_SHEETS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'c'
        })
    })
})()

export const REL_GLOBAL_PRODUCT_SHEETS_BY_STATUS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'c'
        })
    })
})()

export const REL_GREENLINE_PRODUCTS_STORE = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            variantId: 'variantId',
            productId: 'productId'
        }),
        [MODE_PROD]: Object.freeze({
            variantId: 'v',
            productId: 'p'
        })
    })
})()
